<template>
  <NuxtLink to="/">
    modus
  </NuxtLink>
</template>

<style scoped lang="scss">
  a {
    @include h2;

    margin: 0;
    font-size: 40px;
    text-decoration: none;
    align-self: flex-start;
    color: var(--color-blue-50);
  }
</style>
